export default __webpack_public_path__ + "static/media/visible.5561abb9.svg";